import { downloadApiFile } from "./transport";
import type { WorkTarget } from "./workReports";

export const workExportApi = {
  /** The selected Work controller owns record lifetime; shared downloads also pin the initiating profile. */
  async downloadWorkRecord(target: WorkTarget, assertCurrent: () => void): Promise<void> {
    return downloadApiFile(
      `/${target.kind === "contract" ? "contracts" : "engagements"}/${encodeURIComponent(target.id)}/work/export.zip`,
      async disposition => {
        // Cross-origin clients may not see the disposition header. Hash the full ID so long IDs cannot share a truncated native Documents name.
        const recordedName = disposition?.match(/filename="(work-record-(?:contract|engagement)-[a-f0-9]{16}\.zip)"/i)?.[1];
        let fileName = recordedName?.startsWith(`work-record-${target.kind}-`) ? recordedName : undefined;
        if (!fileName) {
          const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(target.id));
          const recordHash = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("").slice(0, 16);
          fileName = `work-record-${target.kind}-${recordHash}.zip`;
        }
        return fileName;
      },
      "Could not create the complete Work download. Please retry, or contact support if it keeps failing.",
      { assertCurrent, serverErrors: true },
    );
  },
};
